import React, { Fragment } from 'react';
import { CheckCircle } from 'lucide-react';
interface Step {
  number: number;
  label: string;
}
interface ProgressStepsProps {
  currentStep: number;
  steps: Step[];
}
/**
 * ProgressSteps component
 * Visual indicator showing multi-step form progress
 */
export function ProgressSteps({
  currentStep,
  steps
}: ProgressStepsProps) {
  return <div className="flex items-center justify-between w-full max-w-md mx-auto mb-8" data-id="element-2448">
      {steps.map((step, index) => <Fragment key={step.number} data-id="element-2449">
          {/* Step Circle */}
          <div className="flex flex-col items-center" data-id="element-2450">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all duration-300 ${step.number < currentStep ? 'bg-[#3ab795] text-white' : step.number === currentStep ? 'bg-[#3ab795] text-white ring-4 ring-[#3ab795]/20' : 'bg-[#1a1a1a] text-gray-500 border-2 border-gray-700'}`} data-id="element-2451">
              {step.number < currentStep ? <CheckCircle className="w-5 h-5" strokeWidth={2.5} data-id="element-2452" /> : step.number}
            </div>
            <p className={`mt-2 text-xs font-medium transition-colors ${step.number <= currentStep ? 'text-white' : 'text-gray-500'}`} data-id="element-2453">
              {step.label}
            </p>
          </div>

          {/* Connector Line */}
          {index < steps.length - 1 && <div className="flex-1 h-px mx-2 relative top-[-12px]" data-id="element-2454">
              <div className={`h-full transition-all duration-500 ${step.number < currentStep ? 'bg-[#3ab795]' : 'bg-gray-700'}`} data-id="element-2455" />
            </div>}
        </Fragment>)}
    </div>;
}